import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { Question } from '../../interfaces/career-setup/question.interface';

import { Observable } from 'rxjs';
import { PageResponse } from '../../interfaces/page-response.interface';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class QuestionService extends BaseService<Question> {
  abstract override findAll(params: CommonSearchParam): Observable<PageResponse<Question>>;
  abstract override find(id: string): Observable<Question>;
  abstract override create(data: Partial<Question>): Observable<Question>;
  abstract override update(id: string, data: Partial<Question>): Observable<Question>;
  abstract updateStatus(id: string, isActive: boolean): Observable<Question>;
  abstract override delete(id: string): Observable<void>;
}
